<app-dc-header>
  <ng-container class="heading"
    >Validated Payloads Results
    <span
      class="badge badge-sm badge-pill badge-success text-medium font-weight-normal ml-2"
      >{{ pass }}</span
    ><span
      class="badge badge-sm badge-pill badge-danger text-medium font-weight-normal ml-2"
      >{{ fail }}</span
    ></ng-container
  >
  <ng-container class="actions">
    <app-dc-download-csv
      [disabled]="disableCsvBtn"
      [fileTitle]="'Validations Summary '"
      (downloadCsvEmitter)="downloadCsvRequest($event)"
      [title]="disableCsvBtn ? 'CSV Downloading...' : 'CSV Download'"
      #csvDownloadComponent
    ></app-dc-download-csv>

    <app-dc-date-input-range
      class="date-range"
      [id]="'datePickerComponent'"
      (dateRangeOut)="dateRangeFunc($event)"
      [placeholder]="'dd/mm/yyyy'"
      [darkMode]="true"
    ></app-dc-date-input-range>
    <div class="searchContainer">
      <app-dc-search
        class=""
        [formControl]="searchControl"
        [placeholder]="'Search'"
        [darkMode]="true"
        (clearFilter)="clearSearchInput($event)"
      ></app-dc-search>
    </div>
  </ng-container>
</app-dc-header>
